module.exports = __webpack_public_path__ + "img/LK.1937c329.png";